import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const GrouploanamortAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		loanaccountno: yup.string().required().label($t('loanaccountno')),
		period: yup.number().required().label($t('period')),
		paydate: yup.string().required().label($t('paydate')),
		payment: yup.number().required().label($t('payment')),
		current_balance: yup.number().required().label($t('currentBalance')),
		interest: yup.number().required().label($t('interest')),
		principal: yup.number().required().label($t('principal')),
		paid: yup.string().nullable().label($t('paid')),
		req_status: yup.string().nullable().label($t('reqStatus')),
		payment_transaction_identifier: yup.string().nullable().label($t('paymentTransactionIdentifier')),
		userid: yup.number().nullable().label($t('userid')),
		overdue_posted: yup.string().required().label($t('overduePosted'))
	});
	
	//form default values
	const formDefaultValues = {
		loanaccountno: '', 
		period: '', 
		paydate: new Date(), 
		payment: '', 
		current_balance: '', 
		interest: '', 
		principal: '', 
		paid: '', 
		req_status: '', 
		payment_transaction_identifier: '', 
		userid: '', 
		overdue_posted: "((0))", 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/grouploanamort`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="GrouploanamortAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewAmort')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanaccountno')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/loanaccountno_option_list_3"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="loanaccountno"     optionLabel="label" optionValue="value" value={formik.values.loanaccountno} onChange={formik.handleChange} options={response} label={$t('loanaccountno')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.loanaccountno)}   />
                                                    <ErrorMessage name="loanaccountno" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('period')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="period"  onChange={formik.handleChange}  value={formik.values.period}   label={$t('period')} type="number" placeholder={$t('enterPeriod')}  min={0}  step="any"    className={inputClassName(formik?.errors?.period)} />
                                                <ErrorMessage name="period" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('paydate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="paydate" showButtonBar className={inputClassName(formik?.errors?.paydate)} dateFormat="yy-mm-dd" value={formik.values.paydate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="paydate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('payment')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="payment"  onChange={formik.handleChange}  value={formik.values.payment}   label={$t('payment')} type="number" placeholder={$t('enterPayment')}  min={0}  step={0.01}    className={inputClassName(formik?.errors?.payment)} />
                                                <ErrorMessage name="payment" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('currentBalance')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="current_balance"  onChange={formik.handleChange}  value={formik.values.current_balance}   label={$t('currentBalance')} type="number" placeholder={$t('enterCurrentBalance')}  min={0}  step={0.01}    className={inputClassName(formik?.errors?.current_balance)} />
                                                <ErrorMessage name="current_balance" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('interest')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="interest"  onChange={formik.handleChange}  value={formik.values.interest}   label={$t('interest')} type="number" placeholder={$t('enterInterest')}  min={0}  step={0.01}    className={inputClassName(formik?.errors?.interest)} />
                                                <ErrorMessage name="interest" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('principal')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="principal"  onChange={formik.handleChange}  value={formik.values.principal}   label={$t('principal')} type="number" placeholder={$t('enterPrincipal')}  min={0}  step={0.01}    className={inputClassName(formik?.errors?.principal)} />
                                                <ErrorMessage name="principal" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('paid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="paid"     optionLabel="label" optionValue="value" value={formik.values.paid} onChange={formik.handleChange} options={app.menus.paid} label={$t('paid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.paid)}   />
                                                <ErrorMessage name="paid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('reqStatus')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="req_status"  onChange={formik.handleChange}  value={formik.values.req_status}   label={$t('reqStatus')} type="text" placeholder={$t('enterReqStatus')}        className={inputClassName(formik?.errors?.req_status)} />
                                                <ErrorMessage name="req_status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('paymentTransactionIdentifier')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="payment_transaction_identifier"  onChange={formik.handleChange}  value={formik.values.payment_transaction_identifier}   label={$t('paymentTransactionIdentifier')} type="text" placeholder={$t('enterPaymentTransactionIdentifier')}        className={inputClassName(formik?.errors?.payment_transaction_identifier)} />
                                                <ErrorMessage name="payment_transaction_identifier" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('userid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label={$t('userid')} type="number" placeholder={$t('enterUserid')}  min={0}  step="any"    className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('overduePosted')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="overdue_posted"  onChange={formik.handleChange}  value={formik.values.overdue_posted}   label={$t('overduePosted')} type="text" placeholder={$t('enterOverduePosted')}        className={inputClassName(formik?.errors?.overdue_posted)} />
                                                <ErrorMessage name="overdue_posted" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
GrouploanamortAddPage.defaultProps = {
	primaryKey: 'amortid',
	pageName: 'grouploanamort',
	apiPath: 'grouploanamort/add',
	routeName: 'grouploanamortadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default GrouploanamortAddPage;
